import styled from 'styled-components'
import Flex from 'src/components/Layout/Flex/Flex'
import Button from 'src/components/Atoms/Button/Button'
import { TagDropdownWrapper } from 'src/components/Molecules/TagDropdown/TagDropdown.styles'
import { CARD_SIZE } from '../utils'
import { SearchToolBarProps, SearchWrapperProps } from './types'

const BREAKPOINT = '1140px'

export const SearchWrapper = styled(Flex).attrs({
  flexDirection: 'column'
}) <SearchWrapperProps>`
  position: relative;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  box-sizing: border-box;
  margin-bottom: ${props => props.addBottomMargin ? '24px' : '0'};
`

export const SearchBackground = styled(Flex)`
  width: 100%;
  background-color: ${props => props.theme.colors.shades.neutral[0]};
`

export const SearchToolBar = styled(Flex).attrs({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
}) <SearchToolBarProps>`
  width: calc(100% - 16px - 16px);
  min-height: 92px;
  padding-top: ${props => props.removePadding ? 0 : '24px'};
  gap: 16px;

  @media (max-width: ${BREAKPOINT}) {
    flex-direction: column;
  }
`

export const DownloadWrapper = styled(Flex).attrs({
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
})`
  width: calc(100% - 16px - 16px);
  padding-top: 24px;
`

export const GetButton = styled(Button)`
  margin-top: 32px;

  @media (max-width: ${BREAKPOINT}) {
    margin-top: 0;
    margin-bottom: 24px;
  }
`

export const DownloadIconWrapper = styled(Flex)`
  cursor: pointer;
`

export const CardStyle = styled(Flex)`
  box-sizing: border-box;
  width: ${CARD_SIZE}px;
  height: 88px;
  gap: 8px;
  padding: 16px;
  user-select: none;
  background-color:  ${props => props.theme.colors.shades.neutral[0]};
  border-radius: 4px;
  border: 1px solid  ${props => props.theme.colors.shades.neutral[1]};
  cursor: pointer;
`

export const ContentContainerStyle = styled(Flex)`
  gap: 4px;
  height: 56px;
`
export const OptionsDropdownWrapper = styled(Flex)<{border?: string}>`
  margin-bottom: 32px;
  padding: 32px;
  border: ${props => props.border || 'none'};
  box-sizing: border-box;
  gap: 16px;

  ${TagDropdownWrapper} {
    ul li div label {
      height: auto;
      padding-bottom: 5px;
      white-space: normal;
    }
  }
`
